import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function HelpDialogContent() {
  return (
    <Box sx={{ mb: "3em" }}>
      <Typography>
        Please click{" "}
        <a
          target="_blank"
          href={`${process.env.PUBLIC_URL}/resources/MO-INDUSTRY-TM.pdf`}
          rel="noopener noreferrer"
        >
          here to view the training material
        </a>
      </Typography>
      <Typography>
        Please contact us at{" "}
        <a href="mailto:cannabisinfo@health.mo.gov" target="_top">
          cannabisinfo@health.mo.gov
        </a>{" "}
        <>
          <span> or </span>
          <a href="tel:+1(866) 219-0165">+1 (866) 219-0165</a>{" "}
        </>
        for any <span>further</span> assistance. Thank you!
      </Typography>
    </Box>
  );
}

export default HelpDialogContent;
